import React, { useEffect, useState } from "react";
import styled, { css } from "styled-components";
import ExitButton from "../buttons/ExitButton";
import { useDispatch, useSelector } from "react-redux";
import TextareaMessageTo from "../inputs/TextareaMessageTo";
import { loadBoardMembers } from "../user/boardMember/boardMembersAction";
import { loadAmbassadors } from "../user/ambassador/ambassadorsAction";
import { BaseModalForm } from "./modalStyle";
import { getImage } from "../../utils/utils";
import accountSVG from "../../images/account.svg";
import {
  sendPitchProject,
  sendPitchStrategy,
} from "../dashboard/dashBoardAction";
import { loadUsers } from "../user/usersAction";
import { FunctionalModal } from "./FunctionalModal";
import SendFormButton from "../buttons/SendFormButton";
import { CLEAR_MESSAGE } from "../message/actions/actionTypes";
const ShareWithTeam = ({ setIsOpenShareWithModal, name, label, preparedText, context, fromguidedUpdate }) => {
  const { members, id: projectId } = useSelector((state) => state.project);
  const { boardMembers } = useSelector((state) => state.boardMembers);
  const { ambassadors } = useSelector((state) => state.ambassadors);
  const { users } = useSelector((state) => state.users);
  const { isPending } = useSelector((state) => state.message);

  const [message, setMessage] = useState( preparedText ?? "");
  const [sections, setSections] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const dispatch = useDispatch();
  useEffect(() => {
    return () => {
      dispatch({ type: CLEAR_MESSAGE });
    };
  }, [dispatch]);

  useEffect(() => {
    dispatch(loadBoardMembers());
    dispatch(loadAmbassadors());
    dispatch(loadUsers());
  }, [dispatch, name]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    let uniqueIds = [...new Set(usersSelected)];
    let data = {};
    data.memberIds = uniqueIds;
    if (message.trim() !== "") {
      data.message = message;
    }
    if (name === "project") {
      await dispatch(sendPitchProject(projectId, data));
    } else {
      await dispatch(sendPitchStrategy(data));
    }
    setIsOpenShareWithModal(false);
  };

  useEffect(() => {
    let initialSections = [
      {
        title: "Ambassadeurs",
        checkboxLabel: "Tous les ambassadeurs",
        members: ambassadors,
      },
      {
        title: "CODIR",
        checkboxLabel: "Tout le CODIR",
        members: boardMembers,
      },
      {
        title: "Collaborateurs",
        checkboxLabel: "Tous les collaborateurs",
        members: users,
      },
    ];

    if (name === "project") {
      initialSections.splice(2, 0, {
        title: "Équipe",
        checkboxLabel: "Toute l'équipe",
        members: members,
      });
    }
    setSections(initialSections);
  }, [ambassadors, boardMembers, members, name, users]);

  const [usersSelected, setUsersSelected] = useState([]);

  const selectAllUsers = (e, members) => {
    const isChecked = e.target.checked;
    const membersId = members.map((m) => m.id);
    const initialMembersSelected = [...usersSelected];
    if (isChecked) {
      membersId.forEach((id) => {
        initialMembersSelected.push(id);
      });
      // remove duplicates item
      const newArray = [...new Set(initialMembersSelected)];
      setUsersSelected(newArray);
    } else {
      membersId.forEach((id) => {
        let indexUserInArray = initialMembersSelected.indexOf(id);
        initialMembersSelected.splice(indexUserInArray, 1);
      });
      setUsersSelected(initialMembersSelected);
    }
  };

  const selectUser = (id) => {
    if (!usersSelected.includes(id)) {
      setUsersSelected([...usersSelected, id]);
    } else {
      let initialUsersSelected = [...usersSelected];
      const indexUserInArray = initialUsersSelected.indexOf(id);
      initialUsersSelected.splice(indexUserInArray, 1);
      setUsersSelected(initialUsersSelected);
    }
  };

  const haveSameValue = (arr1, arr2) => {
    const isContained = (value) => arr1.includes(value);
    return arr2.every(isContained);
  };

  const handleMessage = (e) => {
    const { value } = e.target;
    setMessage(value);
  };
  const handleSearch = (e) => {
    setSearchValue(e.target.value);
  };

  return (
    <FunctionalModal
      component={
        <Modal onSubmit={handleSubmit}>
          <FirstSection>
            <h1> Partager {label} </h1>
            <ExitButton closeUpdate={() => setIsOpenShareWithModal(false)} />
          </FirstSection>
          <p style={{ textAlign: "center", maxWidth: "90%" }}>
            Souhaitez-vous partager {context ? "cette analyse" : "votre Pitch projet"} ?
            (Si oui, choisissez la
            ou les personnes destinataire(s) si non, quitter avec la croix)
          </p>

          <ContainerUsersCategory>
            {sections.map((section) => (
              <UsersWrapper key={section.title}>
                <h2> {section.title} </h2>
                <label className={"label-checkbox"}>
                  {" "}
                  {section.checkboxLabel}
                  <input
                    checked={haveSameValue(
                      usersSelected,
                      section.members.map((m) => m.id)
                    )}
                    type={"checkbox"}
                    onClick={(e) => selectAllUsers(e, section.members)}
                  />
                  <span className="checkmark" />
                </label>
                {section.members === users && (
                  <div>
                    <Input
                      type="text"
                      placeholder="Chercher collaborateur"
                      onChange={handleSearch}
                    />
                    <Wrapper>
                      <div className={"sub-wrapper"}>
                        {searchValue !== ""
                          ? section.members
                              .filter(
                                (member) =>
                                  member.firstName
                                    .toLowerCase()
                                    .includes(searchValue.toLowerCase()) ||
                                  member.lastName
                                    .toLowerCase()
                                    .includes(searchValue.toLowerCase())
                              )
                              .map((member) => (
                                <MemberCard
                                  $mode={usersSelected.includes(member.id)}
                                  key={member.id}
                                  onClick={() => selectUser(member.id)}
                                >
                                  <img
                                    src={getImage(member.photo, accountSVG)}
                                    alt="membre"
                                  />
                                  <p>
                                    <span>{member.firstName} </span>
                                    <span>{member.lastName}</span>
                                  </p>
                                </MemberCard>
                              ))
                          : section.members.map((member) => (
                              <MemberCard
                                $mode={usersSelected.includes(member.id)}
                                key={member.id}
                                onClick={() => selectUser(member.id)}
                              >
                                <img
                                  src={getImage(member.photo, accountSVG)}
                                  alt="membre"
                                />
                                <p>
                                  <span>{member.firstName} </span>
                                  <span>{member.lastName}</span>
                                </p>
                              </MemberCard>
                            ))}
                      </div>
                    </Wrapper>
                  </div>
                )}

                {section.members !== users && (
                  <Wrapper>
                    <div className={"sub-wrapper"}>
                      {section.members.map((member) => (
                        <MemberCard
                          $mode={usersSelected.includes(member.id)}
                          key={member.id}
                          onClick={() => selectUser(member.id)}
                        >
                          <img
                            src={getImage(member.photo, accountSVG)}
                            alt="membre"
                          />
                          <p>
                            <span>{member.firstName} </span>
                            <span>{member.lastName}</span>
                          </p>
                        </MemberCard>
                      ))}
                    </div>
                  </Wrapper>
                )}
              </UsersWrapper>
            ))}
          </ContainerUsersCategory>
          <MessageContainer>
            <TextareaMessageTo
              selectedOption={message}
              handleChange={handleMessage}
              name={"message"}
              placeholder={"Envoyer un message"}
              preparedText={preparedText}
            />
          </MessageContainer>
          <SendFormButton
            state={usersSelected.length !== 0 && !isPending}
            actionName={"Envoyer"}
          />
        </Modal>
      }
      setOpen={setIsOpenShareWithModal}
    />
  );
};
const Input = styled.input`
  font-size: 0.7em;
  color: var(--color-black);
  border: 1px solid rgba(166, 172, 181, 0.6);
  padding: 0.5em;
  border-radius: 10px;
  background: #ffffff;
  width: 50%;

  &:focus {
    outline: none;
  }
`;

const Modal = styled(BaseModalForm)`
  align-items: center;
  gap: 1em;
  position: absolute;
  width: 100%;
  padding-bottom: 1em;

  fieldset {
    border: none;
  }

  label > input {
    opacity: 0;
    position: absolute;
    cursor: pointer;
  }

  .label-checkbox:after {
    content: "";
    position: absolute;
    display: none;
  }

  .label-checkbox {
    display: block;
    position: relative;
    padding-left: 35px;
    margin-bottom: 12px;
    cursor: pointer;
    font-size: 0.9em;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;

    input {
      position: absolute;
      opacity: 0;
      cursor: pointer;
      height: 0;
      width: 0;
    }

    .checkmark {
      position: absolute;
      top: 0;
      left: 0;
      height: 24px;
      width: 24px;
      background-color: rgba(166, 172, 181, 0.6);
    }

    &:hover input ~ .checkmark {
      background-color: rgba(166, 172, 181, 0.6);
    }

    input:checked ~ .checkmark {
      background-color: rgba(51, 148, 246, 1);
    }

    .checkmark:after {
      content: "";
      position: absolute;
      display: none;
    }

    input:checked ~ .checkmark:after {
      display: block;
    }

    .checkmark:after {
      left: 9px;
      top: 5px;
      width: 5px;
      height: 10px;
      border: solid white;
      border-width: 0 3px 3px 0;
      -webkit-transform: rotate(45deg);
      -ms-transform: rotate(45deg);
      transform: rotate(45deg);
    }
  }

  @media (min-width: 700px) {
    width: 600px;
    height: 1000px;
    left: 0;
    right: 0;
    margin: 1em auto;
    overflow-y: auto;
  }
`;
const MessageContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-grow: 1;

  fieldset {
    display: inherit;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
  }

  label {
    display: inherit;
    justify-content: center;
    height: 100%;
    width: 100%;
  }

  textarea {
    width: 90%;
    height: 100%;
    border: 2px solid rgba(166, 172, 181, 0.6);
    padding: 1em;
  }
`;
const FirstSection = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;

  h1 {
    flex-grow: 1;
    text-align: center;
    font-size: 200%;
    padding-top: 1em;
  }

  svg {
    transform: translate(-50%, -50%);
  }
`;
const ContainerUsersCategory = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  flex-grow: 0.7;
  width: 90%;
  // gap: 0.5rem;
`;
const Wrapper = styled.div`
  //margin-bottom: 1em;
  width: 100%;
  overflow-x: auto;

  .sub-wrapper {
    overflow-x: auto;
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    gap: 0.3em;
  }

  @media (min-width: 900px) {
    flex-grow: 1;
    align-items: flex-start;
    justify-content: center;
    max-height: 300px;
  }
`;
const MemberCard = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  min-width: 5rem;
  padding: 0.5rem;
  border-radius: 12px;
  cursor: pointer;
  background-color: var(--color-white);
  width: 5rem;

  :hover {
    background: var(--color-purple-lighten);
  }

  img {
    width: 2.5em;
    height: 2.5em;
    object-fit: cover;
    border-radius: 50%;
  }

  p {
    display: flex;
    flex-direction: column;
    font-size: 10px;
    text-align: center;
    height: 50%;
    width: 100%;

    span {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  ${(props) => {
    switch (props.$mode) {
      case true:
        return css`
          background-color: var(--color-purple-06);

          p {
            span {
              color: var(--color-white);
            }
          }
        `;
      default:
        return css``;
    }
  }}
`;

const UsersWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  h2 {
    text-align: left;
  }

  label {
    text-align: left;
  }
`;

export default ShareWithTeam;
